module.exports = {
  'Application timeout': 'Sesión expirada',
  'Please log in again.': 'Por favor, inicia sesión nuevamente.',
  'For your security, your session has expired for being inactive for more than 10 minutes.': 'Por tu seguridad, tu sesión ha expirado por estar inactiva más de 10 minutos.',
  'Start application': 'Volver a iniciar sesión',
};
